export default "__VITE_ASSET__CqPpZfb1__"